
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

export default {
    mounted() {
        this.$nextTick(
            
        );
    },
    destroyed() {
        
    },
    methods: {
        Contents: function(){
            
            let tl = gsap.timeline({
                scrollTrigger : {
                    trigger :'.scroll_top',
                    start : '100% -20%',
                    scrub : 1
                }
            });
            tl.fromTo('.scroll_top',{autoAlpha : 0 , y : '80%'},{autoAlpha : 1 , y : 0 , ease :'power4.Out'})

            let timeLine = gsap.timeline({
                scrollTrigger : {
                    trigger : ".slide-section",
                    start : "top top",
                    end: "+=" + (window.innerHeight * 11),
                    scrub : 1,
                    pin :".slide-section",
                    pinSpacing : false,
                }
            });
            timeLine.to(".slide-section",{ y:-150 , ease: "power4.out", duration: 10 });
            timeLine.to(".scroll_section_content",{opacity : 1 , ease: "power4.out", duration: 15 });
            gsap.to(".main-title",{opacity:0, duration: 0.6, ease: Power1.easeIn,
                scrollTrigger:{
                    trigger:'.main-title',
                    start: "20% 20%",
                    scrub: 1,
                    markers: false,
                }
            })
        },
        sliderInit: function(){
           //window.addEventListener("load", function() {
            setTimeout(() => {
                let activeSlide = document
                    .querySelector(".startegy .main-slides .slick-active")
                    .querySelector(".slide");
                let theme = activeSlide.getAttribute("data-theme");
                let allsection = document.querySelectorAll(".scrollSection");
                for (let i = 0; i < allsection.length; i++) {
                    const element = allsection[i];
                    element.classList.add("hideSection");
                }
                if (theme == "light") {
                    document.querySelector("body").classList.add("light-Slide");
                } else {
                    document.querySelector("body").classList.remove("light-Slide");
                }
                let activeSlideNumber = activeSlide.getAttribute("id");
                document
                .querySelector(`.scrollSection[data-slide="${activeSlideNumber}"]`)
                .classList.remove("hideSection");
            }, 100);
        },
        changeTheme: function(){
            setTimeout(() => {
                let activeSlide = document
                  .querySelector(".startegy .main-slides .slick-active")
                  .querySelector(".slide");
                let theme = activeSlide.getAttribute("data-theme");
                let allsection = document.querySelectorAll(".scrollSection");
                for (let i = 0; i < allsection.length; i++) {
                  const element = allsection[i];
                  element.classList.add("hideSection");
                }
                if (theme == "light") {
                  document.querySelector("body").classList.add("light-Slide");
                } else {
                  document.querySelector("body").classList.remove("light-Slide");
                }
                let activeSlideNumber = activeSlide.getAttribute("id");
                document
                  .querySelector(`.scrollSection[data-slide="${activeSlideNumber}"]`)
                  .classList.remove("hideSection");
            }, 500);
        },
        scrollTop: function(){
            document.querySelector("body").classList.add("scroll");
            setTimeout(() => {
                const element = document.querySelector("body");
                if (element.classList.contains("scroll")) {
                var hoffset = 75;
                //alert(window.innerHeight + "|" +  document.documentElement.clientHeight + "|" + document.body.clientHeight);
                if(window.matchMedia("(max-width: 1025px)").matches){
                    hoffset = 0;
                    
                }
                const height = document.body.clientHeight - hoffset;
                document.body.scrollTop = height ;
                document.documentElement.scrollTop = height;
                } else {
                document.body.scrollTop = 20 + 'px';
                document.documentElement.scrollTop = 20 + 'px';
                }
            }, 100);
        },
        scrollFullTop: function(){
            document.querySelector("body").classList.add("scroll");
            setTimeout(() => {
                return  window.scrollTo(0,0);
            }, 100);
        },
        
    }
};
